import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import constant from '../../constant'

export default class ChangePassword extends Component {
    render() {
        return (
            <React.Fragment>

                <section className='pricing-area padding-bottom-80px'>
                    <div className="container">
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='setyoupinarea'>
                                    <h3>Change Password</h3>
                                    <p>Change your Login Password.</p>

                                    <div className='btn-setyoupin'>
                                        <Link to={constant.component.ChangePassword.url}>Change Password</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        )
    }
}
